module.exports = new __parcel__URL__("morning-phase.06187377.jpg").toString();